<template>
  <div class="page">
    <Transition name="fade" mode="out-in">
      <HeaderMain
        v-if="currentComponent === 'WhatsappActivation'"
        v-html="
          $t(`page.${componentState.pathToTranslate}.mainheader`, {
            value: numberState,
            msgr: 'Whatsapp',
          })
        "
      />
      <HeaderMain v-else-if="!!componentState?.pathToTranslate" textCenter>{{
        $t(`page.${componentState.pathToTranslate}.mainheader`, {
          value: numberState,
          msgr: "Whatsapp",
        })
      }}</HeaderMain>
    </Transition>
    <Transition name="fade" mode="out-in">
      <component
        :is="componentState.component"
        :number="numberState"
        :numberId="numberIdState"
        :messenger="messengerState"
        @nextStage="onNextAction"
      />
    </Transition>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, watchEffect, onUnmounted } from "vue";
import HeaderMain from "@/components/Recurring/HeaderMain.vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import useCustomActivation from "@/components/activation/api/useCustomActivation";
import usePusherActivation from "@/components/activation/api/usePusherActivation";
// COMPONENTS
import WhatsappActivation from "@/components/activation/WhatsappActivation.vue";
import TimeExpired from "@/components/activation/TimeExpiredActivation.vue";
import GenerationCode from "@/components/activation/GenerationCodeActivation.vue";
import ScanCode from "@/components/activation/ScanCodeActivation.vue";

const { pusherActivation, pusherStatus, pusherKill } = usePusherActivation();
const { getCustomStatus, customStatus } = useCustomActivation();

const router = useRouter();
const route = useRoute();
const store = useStore();

const components = {
  WhatsappActivation: {
    component: WhatsappActivation,
    pathToTranslate: "activation",
  },
  GenerationCode: {
    component: GenerationCode,
    pathToTranslate: "code_gen1",
  },
  TimeExpired: {
    component: TimeExpired,
  },
  ScanCode: {
    component: ScanCode,
  },
};

const currentComponent = ref("WhatsappActivation");

const numberKey = ref("");

const componentState = computed(() => {
  return components[currentComponent.value];
});

const numberState = computed(() => store.state.activation.number);

const messengerState = computed(() => store.state.activation.messenger);

const statusState = computed(() => {
  return {
    pusherStatus: pusherStatus.value,
    customStatus: customStatus.value,
  };
});

/**
 * Эта функция принимает параметр nextStage и выполняет различные действия на основе его значения.
 *
 * @param {string} nextStage - событие, которое передается от детей для определения последующих действий.
 * @return {void}
 */
const onNextAction = (nextStage) => {
  console.debug("check NEXT_STAGE value", nextStage, nextStage.value);
  switch (typeof nextStage === "string" ? nextStage : nextStage.value) {
    case "whatsappActivation":
      currentComponent.value = "WhatsappActivation";
      break;
    case "generationCode":
      if (store.state.activation.isPusher) pusherActivation(numberState.value);
      currentComponent.value = "GenerationCode";
      break;
    case "scanCode":
      currentComponent.value = "ScanCode";
      break;
    case "timeOver":
      currentComponent.value = "TimeExpired";
      break;
    case "integration":
      router.push({ name: "Integration" });
      break;
    case "activated":
    case "successActivation":
      const number = numberState.value;
      store.commit("openDialog", {
        name: "SuccessActivationDialog",
        params: { number },
      });
      // the CRM is picked on the success page now, not before activation
      router.push({ name: "SuccessActivation", query: { messenger: "whatsapp" } });
      break;
    case "errorActivation":
      router.push({ name: "SuccessActivation", query: { messenger: "whatsapp" } });
      break;
    case "oops":
    default:
      // currentComponent.value = "GenerationCode";
      router.push({ name: "Oops" });
      break;
  }
};

watch(
  () => store.state.activation.qrLink,
  (newLink) => {
    if (newLink && componentState.value.pathToTranslate !== "activation") {
      onNextAction("scanCode");
    }
  }
);

watch(
  statusState,
  () => {
    const { pusherStatus, customStatus } = statusState.value;
    if (pusherStatus) {
      if (!store.state.activation.isPusher) {
        getCustomStatus(numberState, messengerState.value);
      } else {
        onNextAction(pusherStatus);
      }
    }
  },
  { deep: true }
);

watchEffect(() => {
  const stage = store.state.activation.nextStageActivation;
  if (!!stage) {
    onNextAction(stage);
  }
});

onMounted(() => {
  if (!store.state.activation.messenger) {
    store.commit("activation/SET_MESSENGER", "whatsapp");
  }
  // если номер передается параметром, а в сторе его нет, то добавляем его в стор
  if (!store.state.activation.number && route?.params?.number) {
    store.commit("activation/SET_NUMBER", route?.params?.number);
  }
});

onUnmounted(() => {
  store.commit("clearNumberData");
});
</script>

<style lang="scss" scoped>
.page {
  padding: 0 20px;

  :deep(.txt) {
    font-weight: 500;
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 850px) {
  .dialog {
    width: 100%;
  }

  .page {
    .block {
      .start {
        .block-header {
          font-size: 20px;
          line-height: 150%;
        }
      }
    }
  }
}

@media screen and (max-width: 680px) {
  .page {
    .block {
      flex-direction: column;
      padding: 15px;
      gap: 20px;

      .img1 {
        margin: auto;
        width: 45%;
        height: 50%;
      }

      .start {
        padding: 0;

        .block-header {
          font-size: 14px;
        }

        ul {
          li {
            line-height: 150%;
            font-size: 12px;
          }
        }

        .btn {
          width: 100%;
        }
      }
    }
  }
}

@media screen and (max-width: 550px) {
}

@media screen and (max-width: 450px) {
  .page .block {
    gap: 0;
  }
}

@media screen and (max-width: 400px) {
  .page {
    .block {
      .start {
        padding: 0;

        .block-header {
          font-size: 12px;
        }
      }
    }
  }
}

// @media screen and (max-width: $tablet-max-size) {
//   .modal {
//     width: 100%;
//   }
// }
</style>
